import { jsx } from "react/jsx-runtime";
import { useStore } from "react-redux";
import React from "react";
const withStore = (Component) => {
  return (props) => {
    const store = useStore();
    return /* @__PURE__ */ jsx(Component, { ...props, store });
  };
};
export default withStore;
